<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><path fill="#B4A8CF" d="M8.1 0 2.52 6.135.9 4.905H0L2.52 9 9 0h-.9Z"/></svg>
